import { showConfirmDialog } from 'vant'
import type { DialogOptions } from 'vant'

export const $confirm = (options: DialogOptions) => {
    return showConfirmDialog({
        title: '温馨提示',
        allowHtml: true,
        className: 'main-dialog main-dialog__confirm',
        theme: 'round-button',
        ...options,
    })
}
